<template lang="pug">
form.columns.align-center.my-2(@submit.prevent='onFilter')
  .pb-1.column.col-auto(v-if="isEnabledFilter('doc.numero_eq')")
    small {{ filters['doc.numero_eq'] }}
    int.form-input.input-sm(:placeholder="filters['doc.numero_eq']" v-model="q['doc.numero_eq']")
  .pb-1.column.col-auto(v-if="isEnabledFilter('doc.ano_eq')")
    small {{ filters['doc.ano_eq'] }}
    year.form-input.input-sm(:placeholder="filters['doc.ano_eq']" v-model="q['doc.ano_eq']")
  .pb-1.column.col-auto(v-if="isEnabledFilter('descricao_cont')")
    small {{ filters['descricao_cont'] }}
    input.form-input.input-sm(v-model='q.descricao_cont')
  .pb-1.column.col-auto(v-if="isEnabledFilter('realizado_em_gteq')")
    small {{ filters['realizado_em_gteq'] }}
    datepicker(v-model="q['realizado_em_gteq']" :placeholder="filters['realizado_em_gteq']" input-class='form-input input-sm')
  .pb-1.column.col-auto(v-if="isEnabledFilter('realizado_em_lteq')")
    small {{ filters['realizado_em_lteq'] }}
    datepicker(v-model="q['realizado_em_lteq']" :placeholder="filters['realizado_em_lteq']" input-class='form-input input-sm' full-day)
  .pb-1.column.col-auto(v-if="isEnabledFilter('usuario_id_eq')")
    small {{ filters['usuario_id_eq'] }}
    fiscal-picker(v-model="q['usuario_id_eq']" sm)
  .pb-1.column.col-auto(v-if="isEnabledFilter('doc.cadastro.contribuinte.cpf_cnpj_eq')")
    small {{ filters['doc.cadastro.contribuinte.cpf_cnpj_eq'] }}
    input-cpf-cnpj.form-input.input-sm(v-model="q['doc.cadastro_contribuinte_cpf_cnpj_eq']")
  .pb-1.column.col-auto(v-if="isEnabledFilter('doc.created_at_gteq')")
    small {{ filters['doc.created_at_gteq'] }}
    datepicker(v-model="q['doc.created_at_gteq']" :placeholder="filters['doc.created_at_gteq']" input-class='form-input input-sm')
  .pb-1.column.col-auto(v-if="isEnabledFilter('doc.created_at_lteq')")
    small {{ filters['doc.created_at_lteq'] }}
    datepicker(v-model="q['doc.created_at_lteq']" :placeholder="filters['doc.created_at_lteq']" input-class='form-input input-sm' full-day)
  .pb-1.column.col-auto(v-if="isEnabledFilter('doc.updated_at_gteq')")
    small {{ filters['doc.updated_at_gteq'] }}
    datepicker(v-model="q['doc.updated_at_gteq']" :placeholder="filters['doc.updated_at_gteq']" input-class='form-input input-sm')
  .pb-1.column.col-auto(v-if="isEnabledFilter('doc.updated_at_lteq')")
    small {{ filters['doc.updated_at_lteq'] }}
    datepicker(v-model="q['doc.updated_at_lteq']" :placeholder="filters['doc.updated_at_lteq']" input-class='form-input input-sm' full-day)
  .pb-1.column.col-auto(v-if="isEnabledFilter('doc.ciencia_em_gteq')")
    small {{ filters['doc.ciencia_em_gteq'] }}
    datepicker(v-model="q['doc.ciencia_em_gteq']" :placeholder="filters['doc.ciencia_em_gteq']" input-class='form-input input-sm')
  .pb-1.column.col-auto(v-if="isEnabledFilter('doc.ciencia_em_lteq')")
    small {{ filters['doc.ciencia_em_lteq'] }}
    datepicker(v-model="q['doc.ciencia_em_lteq']" :placeholder="filters['doc.ciencia_em_lteq']" input-class='form-input input-sm' full-day)
  .pb-1.column.col-auto(v-if="isEnabledFilter('doc.autuado_em_gteq')")
    small {{ filters['doc.autuado_em_gteq'] }}
    datepicker(v-model="q['doc.autuado_em_gteq']" :placeholder="filters['doc.autuado_em_gteq']" input-class='form-input input-sm')
  .pb-1.column.col-auto(v-if="isEnabledFilter('doc.autuado_em_lteq')")
    small {{ filters['doc.autuado_em_lteq'] }}
    datepicker(v-model="q['doc.autuado_em_lteq']" :placeholder="filters['doc.autuado_em_lteq']" input-class='form-input input-sm' full-day)
  .pb-1.column.col-auto(v-if="isEnabledFilter('doc.debito_vence_em_gteq')")
    small {{ filters['doc.debito_vence_em_gteq'] }}
    datepicker(v-model="q['doc.debito_vence_em_gteq']" :placeholder="filters['doc.debito_vence_em_gteq']" input-class='form-input input-sm')
  .pb-1.column.col-auto(v-if="isEnabledFilter('doc.debito_vence_em_lteq')")
    small {{ filters['doc.debito_vence_em_lteq'] }}
    datepicker(v-model="q['doc.debito_vence_em_lteq']" :placeholder="filters['doc.debito_vence_em_lteq']" input-class='form-input input-sm' full-day)
  .pb-1.column.col-auto(v-if="isEnabledFilter('doc.debito_vencido')")
    small {{ filters['doc.debito_vencido'] }}
    select.form-select.select-sm(v-model='debitoVencido')
      option(value='*-*') todos
      option(value='1-*') todos vencidos
      option(value='1-10') até 10 dias
      option(value='11-20') de 11 a 20 dias
      option(value='16-30') de 15 a 30 dias
      option(value='31-45') de 31 a 45 dias
      option(value='46-60') de 46 a 60 dias
      option(value='61-90') de 61 a 90 dias
      option(value='91-*') acima de 90 dias
  .pb-1.column.col-auto(v-if="isEnabledFilter('doc.cadastro_id_eq')")
    small {{ filters['doc.cadastro_id_eq'] }}
    cadastro-picker(v-model="q['doc.cadastro_id_eq']" sm)
  .pb-1.column.col-auto(v-if="isEnabledFilter('doc.modelo_id_eq')")
    small {{ filters['doc.modelo_id_eq'] }}
    doc-modelo-picker(v-model="q['doc.modelo_id_eq']" sm)
  .pb-1.column.col-auto(v-if="isEnabledFilter('doc.fiscal_id_eq')")
    small {{ filters['doc.fiscal_id_eq'] }}
    fiscal-picker(v-model="q['doc.fiscal_id_eq']" sm)
  .pb-1.column.col-auto(v-if="isEnabledFilter('doc.cadastro.zona_eq')")
    small {{ filters['doc.cadastro.zona_eq'] }}
    input.form-input.input-sm(type="tel" :placeholder="filters['doc.cadastro.zona_eq']" v-model="q['doc.cadastro.zona_eq']")
  .pb-1.column.col-auto(v-if="isEnabledFilter('doc.cadastro.quadra_eq')")
    small {{ filters['doc.cadastro.quadra_eq'] }}
    input.form-input.input-sm(type="tel" :placeholder="filters['doc.cadastro.quadra_eq']" v-model="q['doc.cadastro.quadra_eq']")
  .pb-1.column.col-auto(v-if="isEnabledFilter('doc.cadastro.lote_eq')")
    small {{ filters['doc.cadastro.lote_eq'] }}
    input.form-input.input-sm(type="tel" :placeholder="filters['doc.cadastro.lote_eq']" v-model="q['doc.cadastro.lote_eq']")
  .pb-1.column.col-auto(v-if="isEnabledFilter('doc.fiscal.usuario_grupo_id_eq')")
    small {{ filters['doc.fiscal.usuario_grupo_id_eq'] }}
    usuario-grupo-picker(v-model="q['fiscal.usuario_grupo_id_eq']" sm)
  .pb-1.column.col-auto(v-if="isEnabledFilter('comentario_situacao_id_eq')")
    small {{ filters['comentario_situacao_id_eq'] }}
    comentario-situacao-picker(v-model="q.comentario_situacao_id_eq" sm)
  .pb-1.column.col-auto(v-if="isEnabledFilter('doc.situacao_id_eq')")
    small {{ filters['doc.situacao_id_eq'] }}
    doc-situacao-picker(v-model="q['doc.situacao_id_eq']" sm)
  .pb-1.column.col-auto(v-if="isEnabledFilter('doc.existe_senha_web_eq')")
    small {{ filters['doc.existe_senha_web_eq'] }}
    select.form-select.select-sm(v-model="q['doc.existe_senha_web_eq']")
      option(:value='undefined') Todos
      option(:value='true') Sim
      option(:value='false') Não
  .pb-1.column.col-auto(v-if="isEnabledFilter('regularizar_em_vencimento')")
    small {{ filters.regularizar_em_vencimento }}
    select.form-select.select-sm(v-model='regularizar_em_vencimento')
      option(value='') Todos
      option(value='vencido') Vencido
      option(value='a_vencer') À vencer
  .pb-1.column.col-auto(v-if="isEnabledFilter('doc.reincidente_eq')")
    small {{ filters['doc.reincidente_eq'] }}
    int.form-input.input-sm(:placeholder="filters['doc.reincidente_eq']" v-model="q['doc.reincidente_eq']")
  .pb-1.column.col-auto(v-if="isEnabledFilter('doc.tipo_eq')")
    small {{ filters['doc.tipo_eq'] }}
    doc-tipo-select.form-select.select-sm(v-model="q['doc.tipo_eq']")
  .pb-1.column.col-auto(v-if="isEnabledFilter('doc.tipo_entrega_eq')")
    small {{ filters['doc.tipo_entrega_eq'] }}
    select-doc-ciencia-tipo.form-select.select-sm(v-model="q['doc.tipo_entrega_eq']")
  .column.col-auto.pb-1
    small Ordenar por
    order-by(:fields='orderByFields' :query='q' sm)
  .column.col-auto
    .label-padding-top.d-flex
      button.btn.btn-link.tooltip.tooltip-bottom(type='submit' data-tooltip='Filtrar', :disabled='$v.q.$invalid')
        i.fa.fa-search
      enabled-filters(
        :localStorageKey='filterKey'
        :defaultEnabledFilters='defaultEnabledFilters'
        :enabledFilters='enabledFilters'
        :filters='filters'
        :query='q'
        :setEnabledFilters='setEnabledFilters'
      )
      a.btn.btn-link.btn-sm.no-print.tooltip.tooltip-bottom(data-tooltip='Imprimir' onclick="window.print()")
        i.fa.fa-lg.fa-print
      slot(name='additionalButtons')
</template>

<script>
import filterMixin from '@/mixins/filter'

export default {
  mixins: [filterMixin],
  props: {
    filterKey: { type: String, default: 'docs_comentarios_enabled_filters' },
    autoFilter: { type: Boolean, default: false },
    defaultQuery: { type: Object, default: () => {} },
  },
  data() {
    return {
      tmpDebitoVencido: '*-*',
      tmpRegularizarEmVencimento: '',
      filters: {
        'doc.numero_eq': this.$options.filters.tModel('doc.numero'),
        'doc.ano_eq': this.$options.filters.tModel('doc.ano'),
        descricao_cont: 'Contém no comentário',
        usuario_id_eq: 'Usuário do comentário',
        realizado_em_gteq: 'Realizado em início',
        realizado_em_lteq: 'Realizado em fim',
        'doc.created_at_gteq': 'Emissão início',
        'doc.created_at_lteq': 'Emissão fim',
        'doc.updated_at_gteq': 'Doc Alteração início',
        'doc.updated_at_lteq': 'Doc Alteração fim',
        'doc.ciencia_em_gteq': 'Ciência início',
        'doc.ciencia_em_lteq': 'Ciência fim',
        'doc.autuado_em_gteq': 'Autuação início',
        'doc.autuado_em_lteq': 'Autuação fim',
        'doc.debito_vence_em_gteq': 'Vcto débito início',
        'doc.debito_vence_em_lteq': 'Vcto débito fim',
        'doc.debito_vencido': 'Débito vencido',
        'doc.cadastro_id_eq': 'Cadastro',
        'doc.cadastro.contribuinte.cpf_cnpj_eq': this.$options.filters.tModel(
          'contribuinte.cpf_cnpj',
        ),
        'doc.cadastro.zona_eq': this.$options.filters.tModel('cadastro.zona'),
        'doc.cadastro.quadra_eq': this.$options.filters.tModel(
          'cadastro.quadra',
        ),
        'doc.cadastro.lote_eq': this.$options.filters.tModel('cadastro.lote'),
        'doc.fiscal.usuario_grupo_id_eq': this.$options.filters.tModel(
          'usuario.usuario_grupo',
        ),
        'doc.fiscal_id_eq': this.$options.filters.tModel('doc.fiscal'),
        comentario_situacao_id_eq: this.$options.filters.tModel(
          'doc.comentario_situacao',
        ),
        'doc.situacao_id_eq': this.$options.filters.tModel('doc.situacao'),
        'doc.existe_senha_web_eq': this.$options.filters.tModel(
          'doc.existe_senha_web',
        ),
        regularizar_em_vencimento: 'Prazo regularizar',
        'doc.modelo_id_eq': this.$options.filters.tModel('doc.modelo'),
        'doc.reincidente_eq': 'Reincidência',
        'doc.tipo_eq': 'Tipo de documento',
        'doc.tipo_entrega_eq': this.$options.filters.tModel('doc.tipo_entrega'),
      },
      defaultEnabledFilters: ['doc.numero_eq', 'doc.ano_eq'],
      orderByFields: {
        realizado_em: this.$options.filters.tModel('comentario.realizado_em'),
        'usuario.nome': this.$options.filters.tModel('comentario.usuario'),
        'doc.numero': this.$options.filters.tModel('doc.numero'),
        'doc.ano': this.$options.filters.tModel('doc.ano'),
        'doc.valor_total': this.$options.filters.tModel('doc.valor_total'),
        'doc.cadastro.numero': this.$options.filters.tModel('doc.cadastro'),
        'doc.created_at': this.$options.filters.tModel('doc.created_at'),
        'doc.ciencia_em': this.$options.filters.tModel('doc.ciencia_em'),
        'doc.cadastro.zona': this.$options.filters.tModel('cadastro.zona'),
        'doc.cadastro.quadra': this.$options.filters.tModel('cadastro.quadra'),
        'doc.cadastro.lote': this.$options.filters.tModel('cadastro.lote'),
        'doc.fiscal.nome': this.$options.filters.tModel('doc.fiscal'),
      },
    }
  },
  computed: {
    regularizar_em_vencimento: {
      get() {
        return this.tmpRegularizarEmVencimento
      },
      set(value) {
        this.tmpRegularizarEmVencimento = value
        this.$set(
          this.q,
          'doc.regularizar_em_lt',
          value === 'vencido' ? 'now' : undefined,
        )
        this.$set(
          this.q,
          'doc.regularizar_em_gt',
          value === 'a_vencer' ? 'now' : undefined,
        )
      },
    },
    debitoVencido: {
      get() {
        return this.tmpDebitoVencido
      },
      set(v) {
        this.tmpDebitoVencido = v
        const [de, ate] = v.split('-')
        const lteq = this.subDate(de)
        const gteq = this.subDate(ate)
        this.$set(this.q, 'doc.debito_vence_em_gteq', gteq)
        this.$set(this.q, 'doc.debito_vence_em_lteq', lteq)
      },
    },
  },
  validations: {
    q: {},
  },

  methods: {
    subDate(days) {
      if (days === '*') return null
      const d = new Date()
      const date = new Date(
        d.getFullYear(),
        d.getMonth(),
        d.getDate() - Number(days),
        0,
        0,
        0,
        0,
      )

      return date.toJSON()
    },

    onFilter() {
      this.$emit('submit', this.q)
    },
  },

  created() {
    this.q = { ...this.defaultQuery }
    if (this.autoFilter) {
      this.onFilter()
    }
  },
}
</script>

<style lang="stylus" scoped>
.mx-datepicker
  padding: 0
</style>
